import { useSidebar } from '../../contexts/SidebarContext/hook';
import { SidebarButtonLink } from './styles';

interface DashboardButtonLink {
  icon: JSX.Element;
  label: string;
  onClick: () => void;
  isActive?: boolean;
}

export const DashboardButtonLink = ({ icon, label, isActive, onClick }: DashboardButtonLink) => {
  const { isOpen } = useSidebar();

  return (
    <SidebarButtonLink startIcon={icon} aria-label={label} isSidebarOpen={isOpen} isActive={isActive} onClick={onClick}>
      {isOpen ? label : ''}
    </SidebarButtonLink>
  );
};
